import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import LazyLoad from 'react-lazy-load';
import * as _ from 'es-toolkit';
function LazyDisplay(props) {
  const $ = _c(5);
  let t0;
  if ($[0] !== props) {
    t0 = _.omit(props, ["children"]);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.children || $[3] !== t0) {
    t1 = <LazyLoad {...t0}>{props.children}</LazyLoad>;
    $[2] = props.children;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
export type LazyDisplayProps = {
  children?: ReactNode;
  className?: string;
  elementType?: string;
  height?: string | number;
  offset?: string | number;
  threshold?: number;
  width?: number | string;
  onContentVisible?: () => void;
};
export default LazyDisplay;